import EffectAmount from '@/roc/effects/EffectAmount';
class ProductionDuration extends EffectAmount {
    format(level, era) {
        let am = this.calculate(level, era);
        if (this.__calc !== 'hourMinutePerLevel') {
            am /= 60;
            const minute = am % 60;
            const hour = (am - minute) / 60;
            if (minute > 0) {
                am = (hour > 0 ? hour + 'h ' : '') + minute + 'm';
            }
            else if (hour === 24) {
                am = '1d';
            }
            else {
                am = hour + 'h';
            }
        }
        else {
            am = am.replace(' 0m', '');
            if (am === '24h') {
                am = '1d';
            }
        }
        return am;
    }
}
export default ProductionDuration;
